import { render, staticRenderFns } from "./PopupConfirmation.vue?vue&type=template&id=5d8b9b4c"
import script from "./PopupConfirmation.vue?vue&type=script&lang=js"
export * from "./PopupConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports